import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider, useApp } from "./context/AppContext";
import Header from "./components/Header";
import BottomNav from "./components/BottomNav";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import MyPosts from "./pages/MyPosts";
import MySales from "./pages/MySales";
import AdminPanel from "./pages/AdminPanel";
import AdsAdmin from "./pages/AdsAdmin";
import Messages from "./pages/Messages";
import MyPurchases from "./pages/MyPurchases";
import Favorites from "./pages/Favorites";
import Advertise from "./pages/Advertise";
import Terms from "./pages/Terms";
import VerifyEmail from "./pages/VerifyEmail";
import SetPassword from "./pages/SetPassword";
import ResetPassword from "./pages/ResetPassword";
import MyAd from "./pages/MyAd";
import { NewProduct, EditProduct } from "./pages/ProductPages";
import { Login, Register } from "./pages/AuthPages";
import Profile from "./pages/Profile";

function PrivateRoute({ children }) {
  const { currentUser } = useApp();
  return currentUser ? children : <Navigate to="/login" replace />;
}

// Para rutas de comprador/vendedor: los anunciantes no tienen acceso, solo su panel de publicidad
function SellerRoute({ children }) {
  const { currentUser } = useApp();
  if (!currentUser) return <Navigate to="/login" replace />;
  if (currentUser.role === "advertiser") return <Navigate to="/my-ad" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { currentUser } = useApp();
  return currentUser?.role === "admin" ? children : <Navigate to="/" replace />;
}

function HomeRoute({ children }) {
  const { currentUser } = useApp();
  if (currentUser?.role === "advertiser") return <Navigate to="/my-ad" replace />;
  if (currentUser) return <Catalog />; // logueado: "/" muestra el catalogo directo, sin cambiar la URL
  return children;
}

function AppRoutes() {
  const { currentUser } = useApp();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <div style={{paddingBottom: currentUser && isMobile ? 72 : 0}}>
        <Routes>
          <Route path="/"                 element={<HomeRoute><Home /></HomeRoute>} />
          <Route path="/catalog"          element={<Catalog />} />
          <Route path="/login"            element={<Login />} />
          <Route path="/register"         element={<Register />} />
          <Route path="/verify"           element={<VerifyEmail />} />
          <Route path="/set-password"     element={<SetPassword />} />
          <Route path="/reset-password"   element={<ResetPassword />} />
          <Route path="/my-ad"            element={<PrivateRoute><MyAd /></PrivateRoute>} />
          <Route path="/advertise"        element={<Advertise />} />
          <Route path="/terms"            element={<Terms />} />
          <Route path="/profile" element={<SellerRoute><Profile /></SellerRoute>} />
          <Route path="/my-posts"         element={<SellerRoute><MyPosts /></SellerRoute>} />
          <Route path="/my-sales"         element={<SellerRoute><MySales /></SellerRoute>} />
          <Route path="/my-purchases"     element={<SellerRoute><MyPurchases /></SellerRoute>} />
          <Route path="/favorites"        element={<PrivateRoute><Favorites /></PrivateRoute>} />
          <Route path="/new-product"      element={<SellerRoute><NewProduct /></SellerRoute>} />
          <Route path="/edit-product/:id" element={<SellerRoute><EditProduct /></SellerRoute>} />
          <Route path="/admin"            element={<AdminRoute><AdminPanel /></AdminRoute>} />
          <Route path="/admin/ads"        element={<AdminRoute><AdsAdmin /></AdminRoute>} />
          <Route path="/messages"         element={<SellerRoute><Messages /></SellerRoute>} />
          <Route path="*"                 element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <BottomNav />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProvider>
  );
}
